module.exports = __webpack_public_path__ + "img/bian_logo.a160e3d1.png";